import gql from "graphql-tag"

export const questionGroupFieldsFragment = gql`
   fragment questionGroupFields on QuestionGroup {
      uuid
      name
      tenantUuid
      contentId
      etag
   }
`
